import { BsLink } from "react-icons/bs";
import CardsList from "../CardsList/CardsList";
import { IoClose } from "react-icons/io5";
import { IoVideocamOutline } from "react-icons/io5";
import React from "react";
import { useTranslation } from "react-i18next";

const PersonalizationPopup = ({
    onClose,
    onConfirm,
    message,
    setMessage,
    link,
    setLink,
    showLinkInput,
    handleShowLinkInput,
    uploadvideo,
    handleVideoUpload,
    videoUploadProgress,
    isVideoUploading,
    videoErr,
    thumbnail,
    handleThumbnailUpload,
    thumbnailUploadProgress,
    isThumbnailUploading,
    selectedCardDesign,
    setSelectedCardDesign,
    cards,
    cardLoading,
    cardError,
    currentCardIndex,
    setCurrentCardIndex,
    UploadProgressBar,
    isLoading,
    done,
    FaCheck,
    LoaderMini,
}) => {
    const { t } = useTranslation();
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
            <div className="bg-white rounded-xl p-6 w-[23rem] lg:w-[40rem] 
      max-w-4xl h-[90vh] overflow-y-auto relative no-scrollbar">
                <button
                    className="absolute top-4 right-4 text-2xl"
                    onClick={onClose}
                >
                    <IoClose />
                </button>
                <h2 className="text-2xl font-bold m-5 text-center">
                    {t("personalizeYourOrder")}
                </h2>
                <div className="flex w-full flex-col lg:flex-row items-start 
        justify-center mt-10 gap-5">
                    <div className="flex flex-col items-center justify-start gap-1">
                        <h1>{t("chooseDesign")}</h1>
                        <CardsList
                            selectedCard={selectedCardDesign}
                            setSelectedCard={setSelectedCardDesign}
                            currentIndex={currentCardIndex}
                            setCurrentIndex={setCurrentCardIndex}
                            cards={cards}
                            loading={cardLoading}
                            error={cardError}
                        />
                    </div>

                    <div className="px-2 flex flex-col lg:w-1/2 w-full">
                        <h1 className="mb-1 w-full text-center">{t("message")}</h1>
                        <div className="">
                            <textarea
                                className="w-full p-4 border rounded-2xl placeholder:text-sm"
                                value={message}
                                onChange={(e) => setMessage(e.target.value)}
                                placeholder={t("specialMessage")}
                                rows="10"
                            />
                        </div>

                        <div
                            className="mb-4 font-tajawal flex items-center 
                    lg:justify-center justify-between gap-1 w-full"
                        >
                            <button
                                type="button"
                                className="flex items-center justify-center gap-1 text-base lg:text-xs font-medium
                      hover:text-blue-500 flex-col border rounded-2xl p-2 w-full"
                                onClick={handleShowLinkInput}
                            >
                                <p>{t("addLink")}</p>
                                <BsLink />
                            </button>
                            <div className="w-full flex items-center justify-center text-center">
                                <label
                                    htmlFor="videoFile"
                                    className="text-base lg:text-xs font-medium flex items-center justify-center gap-1
                        cursor-pointer hover:text-blue-500 flex-col border rounded-2xl
                        p-2 w-full"
                                >
                                    <p className="whitespace-nowrap">{t("uploadVideo")}</p>
                                    <IoVideocamOutline />
                                </label>
                                <input
                                    type="file"
                                    id="videoFile"
                                    className="w-full p-2 border rounded hidden"
                                    accept="video/*"
                                    onChange={handleVideoUpload}
                                />
                            </div>
                        </div>

                        {/* Video upload progress */}
                        {uploadvideo && (
                            <UploadProgressBar
                                progress={videoUploadProgress}
                                isUploading={isVideoUploading}
                                fileName={uploadvideo}
                            />
                        )}
                        {videoErr && (
                            <div className="text-red-500 text-xs py-2">
                                {videoErr}
                            </div>
                        )}

                        {showLinkInput ? (
                            <input
                                type="text"
                                className="w-full py-2 border rounded-full px-4 my-4"
                                value={link}
                                id="link"
                                onChange={(e) => setLink(e.target.value)}
                                placeholder="Add a reference link"
                            />
                        ) : null}
                    </div>
                </div>

                <div className="flex flex-col lg:flex-row justify-center  mt-6 gap-3">

                    <button
                        className="px-3 h-[58px] bg-purble-2 text-white 
                    rounded-full hover:bg-purble-2/90 transition
                     w-full lg:w-1/2 text-sm lg:text-base"
                        onClick={onConfirm}
                        disabled={isVideoUploading || isThumbnailUploading}
                    >
                        {isLoading ? (
                            <div className="flex items-center justify-center">
                                <LoaderMini color="bg-white" />
                            </div>
                        ) : done ? (
                            <div className="flex items-center justify-center gap-1">
                                <FaCheck />
                                <p>{t("added")}</p>
                            </div>
                        ) : isVideoUploading || isThumbnailUploading ? (
                            <p>{t("uploading")}...</p>
                        ) : (
                            <p>{t("continueToCart")}</p>
                        )}
                    </button>
                    <button
                        onClick={onClose}
                        className="px-3 h-[58px] text-purble-2 
                    rounded-full hover:bg-purble-2/10 transition
                     w-full lg:w-1/2 text-sm lg:text-base border"
                    >
                        {t("continueShopping")}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PersonalizationPopup;
